import axios from 'axios'
import { Message } from 'view-design'
import { BaseUtil } from '@xl/js-utils'

import { API_HOST } from './config'
// 创建axios实例
const service = axios.create({
  baseURL: `${API_HOST}`,
  timeout: 3000,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: false
})

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    const commonParameters = {
      trace_id: BaseUtil.createSu()
    }
    config.params = {
      ...config.params,
      ...commonParameters
    }

    return config
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
service.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    const result = response.data
    return Promise.resolve(result)
  },
  (error) => {
    // 对响应错误做点什么
    (Message as any).error('请求出错')
    return Promise.reject(error)
  }
)

export default service
